import { ModuloListagem } from "../types";

export function potenciaTotalMaiorQuePotenciaMaxima(moduloSelecionado: ModuloListagem | null){
  if (!moduloSelecionado) return {status: false, potenciaMaxima: 0};

  const moduloPotenciaMaxima = moduloSelecionado?.potenciaMaxima || 0
  if (!moduloPotenciaMaxima) return { status: false, potenciaMaxima: 0 }
  
  const potenciaTotalInWatts = Number(moduloSelecionado?.quantidade || 0) * Number(moduloSelecionado?.potencia ||0)
  const potenciaTotalInKw = potenciaTotalInWatts / 1000
  
  if (potenciaTotalInKw <= moduloPotenciaMaxima) return {status: false, potenciaMaxima: 0}
  
  return {status: true, potenciaMaxima: moduloPotenciaMaxima}
}